import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import { useGlobalState } from "../../components/globalState/GlobalStateProvider";
import { Panel } from 'primereact/panel';
import { useEffect, useState } from 'react';
import BarChart from './BarChart';
import graficoConsumo from '../../service/consumo';
import { MeterGroup } from 'primereact/metergroup';
import { Knob } from 'primereact/knob';
import { formatarParaMoedaBRL } from '../../utils';


export default function Page() {
  const { t } = useTranslation();
  const { state } = useGlobalState();
  const [grafico, setGrafico] = useState<any>(null);
  const [graficoHoje, setGraficoHoje] = useState<any>(null);
  const [consumoDiarioPorDia, setConsumoDiarioPorDia] = useState<any>([]);
  const [consumoDiarioPorProduto, setConsumoDiarioPorProduto] = useState<any>([]);
  const [quantidadeConsultaDiario, setQuantidadeConsultaDiario] = useState<any[]>([]);
  const [quantidadeConsultaMes, setQuantidadeConsultaMes] = useState<any[]>([]);


  const getMes = () => {
    return ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][new Date().getMonth()];
  }

  const lebels = ({ values }: { values: any[] }) => (
    <div className="flex flex-wrap gap-3">
      {values.map((item, index) => (
        <p><span><i style={{ color: item.color }} className={item.icon}></i></span><span style={{ fontSize: 'small' }}> {item.label}</span><span> {item.valor}</span></p>
      ))}
    </div>
  );

  const colors = ['#60a5fa', '#34d399', '#F59C27', '#c084fc', '#fbbf24']

  const getValue = (item: any, index: number) => {
    return [{ valor: formatarParaMoedaBRL(item.valor), label: item.data, value: item.percentual, color: index === -1 ? '#4c63b6' : colors[index], icon: index === -1 ? 'pi pi-chart-line' : 'pi pi-dollar' }];
  }

  useEffect(
    () => {
      graficoConsumo(state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null).then((response) => {
        setConsumoDiarioPorProduto(response.consumoDiarioPorProduto)
        setConsumoDiarioPorDia(response.consumoDiarioPorDia)
        if (response.quantidadeConsultaDiario) {
          setQuantidadeConsultaDiario([...response.quantidadeConsultaDiario].sort((a: any, b: any) => b.quantidade - a.quantidade));
        }
        if (response.quantidadeConsultaMes) {
          setQuantidadeConsultaMes([...response.quantidadeConsultaMes].sort((a: any, b: any) => b.quantidade - a.quantidade));
        }
        const data = response.consumoMensal
        const dataHoje = response.consumoDiario
        const series: any[] = [];
        const seriesDropdown: any[] = [];
        Object.getOwnPropertyNames(data).forEach(item => {
          let total = Number(0);
          const dadosPai: any[] = [];
          Object.getOwnPropertyNames(data[item]).forEach(itemValor => {
            const dados: any[] = [];
            dados.push(itemValor)
            dados.push(Number(data[item][itemValor]))
            total = total + Number(data[item][itemValor]);
            dadosPai.push(dados)
          })
          dadosPai.sort((b: any, a: any) => {
              if (!a[1]) {
                return 1;
              }

              if (!b[1]) {
                return -1;
              }

              if (a[1] > b[1]) {
                return 1;
              }
              if (a[1] < b[1]) {
                return -1;
              }
              return 0;
          });
          seriesDropdown.push({ name: item, id: item, data: dadosPai })
          series.push({ name: item, y: total, drilldown: item })
        })
        series.sort((b: any, a: any) => {
            if (!a.y) {
              return 1;
            }

            if (!b.y) {
              return -1;
            }

            if (a.y > b.y) {
              return 1;
            }
            if (a.y < b.y) {
              return -1;
            }
            return 0;
        });
        setGrafico({ series: series, seriesDropdown: seriesDropdown })
        const seriesHoje: any[] = [];
        const seriesDropdownHoje: any[] = [];
        Object.getOwnPropertyNames(dataHoje).forEach(item => {
          let total = Number(0);
          const dadosPai: any[] = [];
          Object.getOwnPropertyNames(dataHoje[item]).forEach(itemValor => {
            const dados: any[] = [];
            dados.push(itemValor)
            dados.push(Number(dataHoje[item][itemValor]))
            total = total + Number(dataHoje[item][itemValor]);
            dadosPai.push(dados)
          })
          dadosPai.sort((b: any, a: any) => {
              if (!a[1]) {
                return 1;
              }

              if (!b[1]) {
                return -1;
              }

              if (a[1] > b[1]) {
                return 1;
              }
              if (a[1] < b[1]) {
                return -1;
              }
              return 0;
          });
          seriesDropdownHoje.push({ name: item, id: item, data: dadosPai })
          seriesHoje.push({ name: item, y: total, drilldown: item })
        })
        seriesHoje.sort((b: any, a: any) => {
            if (!a.y) {
              return 1;
            }

            if (!b.y) {
              return -1;
            }

            if (a.y > b.y) {
              return 1;
            }
            if (a.y < b.y) {
              return -1;
            }
            return 0;
        });
        setGraficoHoje({ series: seriesHoje, seriesDropdown: seriesDropdownHoje })

      })
    }, [])

  return (
    <Container>
      <div className="row">
        <div className="col-lg-12 mb-3">
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray"><i className="pi pi-chart-bar" style={{ fontSize: '2.0rem' }}></i> {t('consumo')}</h1>
          </div>
        </div>
      </div>

      {grafico && (
        <Panel className="panel-renda" header={t('dashboard')} style={{ width: '99%' }}>
          <div className='grid'>
            <div style={{ width: '22%', paddingRight: '1rem' }}>
              <div style={{ height: '28rem' }} className='card col-12 lg:col-6'>
                <h5 style={{ marginTop: '0' }}>Últimos consumos</h5>
                {consumoDiarioPorDia.map((item: any, index: number) => (
                  <div>
                    <MeterGroup labelList={lebels} labelPosition="start" values={getValue(item, index)} />
                    <br></br>
                  </div>
                ))}


                <br></br>
                <br></br>
              </div>
            </div>
            <div style={{ width: '50%', paddingRight: '1rem' }}>
              <div style={{ height: '28rem' }} className='card col-12 lg:col-6'>
                <h5 style={{ marginTop: '0' }}>Consumo de hoje</h5>
                <BarChart key={'chartHoje'} series={graficoHoje.series} seriesDropdown={graficoHoje.seriesDropdown} title={'Consumo realizado hoje '}></BarChart>
              </div>
            </div>
            <div style={{ width: '28%' }}>
              <div style={{ height: '28rem' }} className='card col-12 lg:col-6'>
                <h5 style={{ marginTop: '0' }}>Maiores consumos de hoje por produto</h5>
                <div className='grid' style={{ textAlign: 'center', justifyContent: 'center', gap: '2rem' }}>
                  {consumoDiarioPorProduto.map((item: any) => (
                    <div style={{ textAlign: 'center', justifyContent: 'center' }}>
                      <p style={{ fontSize: 'x-small', width: '6rem' }}>{item.data}</p>
                      <Knob value={item.percentualGeral} size={100} strokeWidth={10} valueTemplate={'{value}%'} valueColor="#4c63b6" />
                    </div>
                  ))}
                </div>
                <br></br>
                <br></br>
                {consumoDiarioPorProduto.map((item: any) => (
                  <div>
                    <MeterGroup labelList={lebels} labelPosition="start" values={getValue(item, -1)} />
                    <br></br>
                  </div>
                ))}
                <br></br>

                <br></br>
              </div>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="grid ">

            <div className="col-6 p-fluid">
              <div className='card' style={{ height: '28rem', overflowY: 'auto' }}>
                <h5 style={{ marginTop: '0' }}>Quantidade Consultas Diárias</h5>
                {quantidadeConsultaDiario.length > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: '0.5rem', marginBottom: '1rem' }}>
                    {quantidadeConsultaDiario.length > 1 && (
                      <div style={{ textAlign: 'center', width: '30%' }}>
                        <span style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{quantidadeConsultaDiario[1].consulta}</span>
                        <div style={{ background: '#C0C0C0', borderRadius: '6px 6px 0 0', height: '4.5rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#fff' }}>
                          <span style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>🥈</span>
                          <span style={{ fontWeight: 'bold', fontSize: '0.85rem' }}>{quantidadeConsultaDiario[1].quantidade}</span>
                        </div>
                      </div>
                    )}
                    <div style={{ textAlign: 'center', width: '30%' }}>
                      <span style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{quantidadeConsultaDiario[0].consulta}</span>
                      <div style={{ background: '#FFD700', borderRadius: '6px 6px 0 0', height: '6rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#fff' }}>
                        <span style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>🥇</span>
                        <span style={{ fontWeight: 'bold', fontSize: '0.95rem' }}>{quantidadeConsultaDiario[0].quantidade}</span>
                      </div>
                    </div>
                    {quantidadeConsultaDiario.length > 2 && (
                      <div style={{ textAlign: 'center', width: '30%' }}>
                        <span style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{quantidadeConsultaDiario[2].consulta}</span>
                        <div style={{ background: '#CD7F32', borderRadius: '6px 6px 0 0', height: '3.5rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#fff' }}>
                          <span style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>🥉</span>
                          <span style={{ fontWeight: 'bold', fontSize: '0.8rem' }}>{quantidadeConsultaDiario[2].quantidade}</span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {quantidadeConsultaDiario.map((item: any, index: number) => {
                    const total = quantidadeConsultaDiario.reduce((acc: number, i: any) => acc + i.quantidade, 0);
                    const percentual = total > 0 ? Math.round((item.quantidade / total) * 100) : 0;
                    return (
                      <li key={index} style={{ padding: '0.3rem 0' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span>{item.consulta}</span>
                          <span style={{ fontWeight: 'bold' }}>{item.quantidade} ({percentual}%)</span>
                        </div>
                        <MeterGroup labelList={lebels} labelPosition="start" values={[{ value: percentual, color: '#0b655b' }]} />
                        <br></br>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-6 p-fluid">
              <div className='card' style={{ height: '28rem', overflowY: 'auto' }}>
                <h5 style={{ marginTop: '0' }}>Quantidade Consultas Mensais</h5>
                {quantidadeConsultaMes.length > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: '0.5rem', marginBottom: '1rem' }}>
                    {quantidadeConsultaMes.length > 1 && (
                      <div style={{ textAlign: 'center', width: '30%' }}>
                        <span style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{quantidadeConsultaMes[1].consulta}</span>
                        <div style={{ background: '#C0C0C0', borderRadius: '6px 6px 0 0', height: '4.5rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#fff' }}>
                          <span style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>🥈</span>
                          <span style={{ fontWeight: 'bold', fontSize: '0.85rem' }}>{quantidadeConsultaMes[1].quantidade}</span>
                        </div>
                      </div>
                    )}
                    <div style={{ textAlign: 'center', width: '30%' }}>
                      <span style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{quantidadeConsultaMes[0].consulta}</span>
                      <div style={{ background: '#FFD700', borderRadius: '6px 6px 0 0', height: '6rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#fff' }}>
                        <span style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>🥇</span>
                        <span style={{ fontWeight: 'bold', fontSize: '0.95rem' }}>{quantidadeConsultaMes[0].quantidade}</span>
                      </div>
                    </div>
                    {quantidadeConsultaMes.length > 2 && (
                      <div style={{ textAlign: 'center', width: '30%' }}>
                        <span style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{quantidadeConsultaMes[2].consulta}</span>
                        <div style={{ background: '#CD7F32', borderRadius: '6px 6px 0 0', height: '3.5rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#fff' }}>
                          <span style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>🥉</span>
                          <span style={{ fontWeight: 'bold', fontSize: '0.8rem' }}>{quantidadeConsultaMes[2].quantidade}</span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {quantidadeConsultaMes.map((item: any, index: number) => {
                    const total = quantidadeConsultaMes.reduce((acc: number, i: any) => acc + i.quantidade, 0);
                    const percentual = total > 0 ? Math.round((item.quantidade / total) * 100) : 0;
                    return (
                      <li key={index} style={{ padding: '0.3rem 0' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span>{item.consulta}</span>
                          <span style={{ fontWeight: 'bold' }}>{item.quantidade} ({percentual}%)</span>
                        </div>
                        <MeterGroup labelList={lebels} labelPosition="start" values={[{ value: percentual, color: '#0b655b' }]} />
                        <br></br>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="grid">
            <div className="col p-fluid flex flex-wrap">
              <div >
                <BarChart series={grafico.series} seriesDropdown={grafico.seriesDropdown} title={'Consumo realizado no mês de ' + getMes()}></BarChart>
              </div>
            </div>
          </div>



        </Panel>
      )}

    </Container>
  )
}